import React from 'react';
import styles from './O_Calendar.module.css';
import cn from 'classnames';
import A_Day from '@/components/A_Atoms/A_Day/A_Day';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import {
  useCalendar,
  monthNames,
  weekdays,
  isSameDay,
} from '@/hooks/useCalendar';

interface O_CalendarProps {
  value?: Date;
  onChange?: (date: Date) => void;
  minDate?: Date;
  maxDate?: Date;
  className?: string;
}

export default function O_Calendar({
  value,
  onChange,
  minDate,
  maxDate,
  className,
}: O_CalendarProps) {
  const {
    currentYear,
    currentMonth,
    grid,
    selectedDate,
    isDateDisabled,
    goPrevMonth,
    goNextMonth,
    goPrevYear,
    goNextYear,
    selectDate,
  } = useCalendar({ value, onChange, minDate, maxDate });

  return (
    <div className={cn(styles.wrapper, className)}>
      <div className={styles.header}>
        <div className={styles.month_control}>
          <button
            type='button'
            className={styles.nav_button}
            onClick={goPrevMonth}
            aria-label='Предыдущий месяц'
          >
            <Q_Icon.ArrowLeftIcon width={16} height={16} />
          </button>
          <span className={cn(styles.title, 'text-p-2')}>
            {monthNames[currentMonth]}
          </span>
          <button
            type='button'
            className={styles.nav_button}
            onClick={goNextMonth}
            aria-label='Следующий месяц'
          >
            <Q_Icon.ArrowRightIcon width={16} height={16} />
          </button>
        </div>

        <div className={styles.year_control}>
          <button
            type='button'
            className={styles.nav_button}
            onClick={goPrevYear}
            aria-label='Предыдущий год'
          >
            <Q_Icon.ArrowLeftIcon width={16} height={16} />
          </button>
          <span className={cn(styles.title, 'text-p-2')}>{currentYear}</span>
          <button
            type='button'
            className={styles.nav_button}
            onClick={goNextYear}
            aria-label='Следующий год'
          >
            <Q_Icon.ArrowRightIcon width={16} height={16} />
          </button>
        </div>
      </div>

      <div className={styles.calendar_wrapper}>
        <div className={styles.weekdays_row}>
          {weekdays.map(w => (
            <div key={w} className={styles.weekday}>
              <span className='text-p-3'>{w}</span>
            </div>
          ))}
        </div>
        <div className={styles.grid}>
          {grid.map(({ date, outside }) => {
            const disabled = isDateDisabled(date, outside);
            const selected = isSameDay(date, selectedDate);
            return (
              <A_Day
                key={date.toISOString()}
                day={date.getDate()}
                selected={selected}
                disabled={disabled}
                onClick={() => selectDate(date, disabled)}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
